<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable no-undef -->
<template>
  <div id="app">
    <div v-if="showHelp" class="message_box help">
      <div class="content">
        <span class="title">HOW TO CHANGE THE DATE</span>
        <span class="subtitle">iPHONE</span>
        <div class="msg">
          <ol style="list-style-type:decimal">
            <li>Go to Settings > General > Date & Time</li>
            <li>Turn off Set Automatically</li>
            <li>change the date to<br/><b>4 nov 2022</b></li>
          </ol>
        </div>
        <span class="subtitle">ANDROID</span>
        <div class="msg">
          <ol style="list-style-type:decimal">
            <li>Go to Settings > SYSTEM > Date AND Time</li>
            <li>Turn off Set Automatic DATE AND TIME</li>
            <li>change the date to<br/><b>4 nov 2022</b></li>
          </ol>
        </div>
        <div class="btn" @click="showHelp = false">CLOSE</div>
      </div>
    </div>

    <div v-if="isPC" class="pc">
      <div class="message_box">
        <div class="content">
          <span class="title">WARNING</span>
          <div class="msg">YOUR DEVICE IS NOT SUPPORTED. TO GO BACK TO THE FUTURE, USE YOUR SMARTPHONE.</div>
        </div>
      </div>
    </div>

    <template v-else>
      <div class="message_box" v-if="showMsg" @click="continueHandler">
        <div class="content">
          <span class="title">WARNING</span>
          <div class="msg">THIS WEBSITE USES YOUR SPEAKERS OR HEADPHONES. PLEASE MAKE SURE THAT YOUR VOLUME IS TURNED ON.</div>
          <div class="btn">CONTINUE</div>
        </div>
      </div>

      <div v-if="playMusic" class="music_view">
        <div class="controls">
          <div class="subtitile">DAVID GUETTA & MORTEN</div>
          <div class="title">
            <span class="ep">EPISODE</span>
            <span class="num">2</span>
          </div>
          <a href="https://futurerave.lnk.to/episode2" class="btn" target="_blank">PRE-SAVE</a>
        </div>
        <div class="logo"></div>
      </div>

      <div v-else class="main_view">
        <div class="content">
          <div class="header">
            <div class="title">
              <span class="name">DAVID GUETTA</span>
              <span class="name">& MORTEN</span>
            </div>
            <span class="subtitile">PRESENTS</span>
            <div class="logo">
              <span class="back">back to the</span>
              <div class="svg_logo"></div>
            </div>
          </div>
          <div class="footer">
            <div class="msg">Сhange the date on your phone to</div>
            <div class="date">
              <span class="dd">04</span>
              <span class="mm">NOV</span>
              <span class="dd">2022</span>
            </div>
            <div class="msg">to listen to the EP before THE release</div>
            <div class="btn" @click="showHelp = true">how to change</div>
          </div>
        </div>
        <div class="bg">
          <video autoplay muted loop playsinline autobuffer preload="auto" id="video_bg" class="video_bg">
            <source src="./assets/FR Background Video.mp4" type="video/mp4">
          </video>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
var m_analyzer;
var m_renderer;
var m_render_queue;
var m_blob;
var m_pbr;
var m_light;
var m_device_checker;

var init = function(audio) {
    // eslint-disable-next-line no-undef
    m_device_checker = new DeviceChecker();
    // eslint-disable-next-line no-unused-vars
    var _is_retina = m_device_checker.is_retina();

    // init audio input analyzer
    // eslint-disable-next-line no-undef
    m_analyzer = new AudioAnalyzer(audio);
    
    // init shared renderer
    var _is_perspective = true;
    // eslint-disable-next-line no-undef
    m_renderer = new ThreeSharedRenderer(_is_perspective);
    m_renderer.append_renderer_to_dom(document.body);
    m_renderer.renderer.autoClear = true;

    // init pbr
    // eslint-disable-next-line no-undef
    m_pbr = new ThreePBR();
    // init light
    // eslint-disable-next-line no-undef
    m_light = new ThreePointLight();

    // init blob
    // eslint-disable-next-line no-undef
    m_blob = new NoiseBlob(m_renderer, m_analyzer, m_light);
    m_blob.set_PBR(m_pbr);
    
    if(_is_retina) m_blob.set_retina();
    
    // setup render queue
    m_render_queue = [
        m_blob.update.bind(m_blob)
    ];
};


var update = function() {
    requestAnimationFrame( update );

    // update audio analyzer
    m_analyzer.update();

    // update blob
    m_blob.update_PBR();

    // update pbr
    m_pbr.exposure = 5. 
        + 30. * m_analyzer.get_level();

    m_renderer.render(m_render_queue);
};

export default {
  name: 'App',

  data() {
    return {
      now: new Date(),
      target: new Date('2022-11-04T00:00:00'),
      
      showMsg: false,
      showHelp: false,
      isPC: false,

      audio: null,
      PATH: '/frep2_192.mp3',
    };
  },

  computed: {
    playMusic() {
      return this.now >= this.target;
    },
  },

  watch: {
    playMusic: {
      immediate: true,
      handler(nv) {
        if (nv && this.audio && !this.showMsg) {
          this.audio.play();
          this.initEq();
        }
      },
    },
  },

  mounted() {
    this.isPC = !navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
    this.makeAudio();
    this.calcNow();
    document.addEventListener('touchstart', () => {
      let videoElement = document.getElementById('home_video');
      videoElement.play();
    });
  },

  methods: {
    calcNow() {
      this.now = new Date();
      if (this.now < this.target) {
        setTimeout(this.calcNow, 1000);
      } else {
        this.showMsg = true;
      }
    },
    makeAudio() {
      this.audio = new Audio(this.PATH);
      this.audio.preload = 'auto';
      this.audio.loop = true;
      this.audio.volume = 1;
    },
    initEq() {
      init(this.audio);
      update();
    },
    continueHandler() {
      this.showMsg = false;
      if (this.playMusic) {
        this.audio.play();
        this.initEq();
      }
    },
  },
}
</script>

<style lang="scss">
@charset "UTF-8";

@font-face {
  font-family: 'Heading Now 56 Bold';
  src: local('Heading Now 56 Bold'), local('Heading-Now-56-Bold'),
      url('./assets/FR Fonts/Heading Now 56 Bold.ttf') format('truetype');
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Paladins';
  src: local('Paladins'),
      url('./assets/FR Fonts/Paladins.ttf') format('truetype');
  font-style: normal;
  font-display: swap;
}

$black: #141414;
$white: #F8F8F8;

canvas{
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  filter: hue-rotate(180deg);
}

#app{
  width: 100vw;
  height: 100vh;
  background-color: $black;
  color: $white;
  font-family: 'Helvetica', sans-serif;
  font-size: 16px;
  font-weight: regular;
  color: $white;
  user-select: none;
  overflow: hidden;
  .main_view{
    width: 100%;
    height: 100%;
    .bg{
      position: fixed;
      z-index: 1;
      right: 0;
      bottom: 0;
      top: 0;
      left: 0;
      .video_bg{
        object-fit: cover;
        background-size: cover;
        width: 100%;
        height: 100%;
      }
    }
    .content{
      position: fixed;
      z-index: 2;
      right: 0;
      bottom: 0;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 2vh 0 4vh;
      .header{
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
          font-family: 'Heading Now 56 Bold';
          font-size: 32px;
          display: flex;
          flex-direction: column;
          align-items: center;
          line-height: 28px;
        }
        .subtitile{
          font-size: 9px;
          margin: 16px 0;
          font-weight: 300;
        }
        .logo{
          display: flex;
          flex-direction: column;
          align-items: center;
          .back{
            font-family: 'Paladins';
            font-size: 24px;
          }
          .svg_logo{
            width: 88vw;
            height: 80px;
            background: url('./assets/FR FULL LOGO.svg') no-repeat center/contain;
          }
        }
      }
      .footer{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-transform: uppercase;
        .msg{
          font-family: 'Heading Now 56 Bold';
          font-size: 16px;
          &:first-child{
            font-size: 18px;
          }
        }
        .date{
          display: flex;
          align-items: baseline;
          margin: 0px 0 4px;
          color: #B5E4FF;
          line-height: 48px;
          .dd{
            font-size: 48px;
          }
          .mm{
            font-family: 'Heading Now 56 Bold';
            font-size: 46px;
            margin: 0 8px;
          }
        }
        .btn{
          font-family: 'Heading Now 56 Bold';
          font-size: 20px;
          color: #B5E4FF;
          text-decoration: underline;
          margin-top: 20px;
          cursor: pointer;
        }
      }
    }
  }
  .music_view{
    width: 100%;
    height: 100%;
    .logo{
      position: fixed;
      z-index: 2;
      width: 100vw;
      height: 100vw;
      bottom: 0;
      background: url('./assets/logo.svg') no-repeat center/contain;
    }
    .controls{
      position: fixed;
      z-index: 3;
      right: 0;
      bottom: 0;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      box-sizing: border-box;
      padding-bottom: 6vh;
      .subtitile{
        font-family: 'Heading Now 56 Bold';
        font-size: 18px;
      }
      .title{
        display: flex;
        align-items: baseline;
        margin-bottom: 8px;
        .ep{
          font-family: 'Heading Now 56 Bold';
          margin-right: 8px;
          font-size: 44px;
        }
        .num{
          font-size: 46px;
        }
      }
      .btn{
        cursor: pointer;
        font-family: 'Heading Now 56 Bold';
        font-size: 20px;
        padding: 16px 44px;
        background-color: $white;
        color: $black;
        text-decoration: none;
      }
    }
  }

  .message_box{
    position: fixed;
    z-index: 9;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .65);
    .content{
      position: fixed;
      width: 80vw;
      height: 80vw;
      padding: 0 40px;
      top: calc(50% - 40vw);
      left: calc(50% - 40vw);
      background-color: $white;
      color: $black;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-family: 'Heading Now 56 Bold';
        font-size: 42px;
      }
      .msg{
        text-align: center;
        margin-top: 36px;
      }
      .btn{
        cursor: pointer;
        font-family: 'Heading Now 56 Bold';
        font-size: 20px;
        margin-top: 40px;
        padding: 8px 40px;
        background-color: $black;
        color: $white;
      }
    }
    &.help{
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      b{
        font-weight: bold;
      }
      ol{
        margin-left: 20px;
        line-height: 18px;
      }
      .content{
        position: relative;
        height: auto;
        padding: 40px 20px 20px;
        top: auto;
        left: auto;
        .title{
          font-family: 'Heading Now 56 Bold';
          font-size: 22px;
        }
        .subtitle{
          font-family: 'Heading Now 56 Bold';
          font-size: 20px;
          margin: 20px 0 16px;
        }
        .msg{
          text-align: left;
          margin: 0;
        }
      }
    }
  }
  .pc{
    .message_box{
      .content{
        width: 360px;
        height: 360px;
        top: calc(50% - 180px);
        left: calc(50% - 180px);
      }
    }
  }
}
</style>
